'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dCredentials$002dPage$0024 from "./presto.-List-Credentials-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002461 from "./presto.-Presto-Router$$anon$61.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$60() {
  this.bk2 = null;
  this.bjU = null;
  this.bjV = false;
  this.bk3 = null;
  this.bk4 = false;
  this.bk7 = null;
  this.bk0 = null;
  this.bk1 = false;
  this.bjW = null;
  this.bjX = false;
  this.bjY = null;
  this.bjZ = false;
  this.bk5 = false;
  this.bk6 = false;
  this.bk2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bk7 = "ListCredentialsPage";
}
export { $c_Lpresto_PrestoRouter$$anon$60 as $c_Lpresto_PrestoRouter$$anon$60 };
$p = $c_Lpresto_PrestoRouter$$anon$60.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$60;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$60() {
}
export { $h_Lpresto_PrestoRouter$$anon$60 as $h_Lpresto_PrestoRouter$$anon$60 };
$h_Lpresto_PrestoRouter$$anon$60.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bk2;
});
$p.M = (function() {
  if ((!this.bjV)) {
    this.bjU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bjV = true;
  }
  return this.bjU;
});
$p.O = (function() {
  if ((!this.bk4)) {
    this.bk3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bk4 = true;
  }
  return this.bk3;
});
$p.E = (function() {
  return this.bk7;
});
$p.t = (function() {
  if ((!this.bk1)) {
    this.bk0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bk1 = true;
  }
  return this.bk0;
});
$p.N = (function() {
  if ((!this.bjX)) {
    this.bjW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().ep())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bjX = true;
  }
  return this.bjW;
});
$p.Q = (function() {
  if ((!this.bjZ)) {
    this.bjY = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002461.$c_Lpresto_PrestoRouter$$anon$61();
    this.bjZ = true;
  }
  return this.bjY;
});
$p.v = (function() {
  if ((!this.bk6)) {
    this.bk5 = false;
    this.bk6 = true;
  }
  return this.bk5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee447) => ((p) => \u03b4scrutinee447.cFy(p)))($j_presto$002e$002dList$002dCredentials$002dPage$0024.$m_Lpresto_ListCredentialsPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$60 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$60, "presto.PrestoRouter$$anon$60", ({
  OC: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$60 as $d_Lpresto_PrestoRouter$$anon$60 };
//# sourceMappingURL=presto.-Presto-Router$$anon$60.js.map
